export default __webpack_public_path__ + "static/media/3338-chefturing.44f0d00c.pdf";